import { render, staticRenderFns } from "./ProductCardPrice.vue?vue&type=template&id=097ad768&"
import script from "./ProductCardPrice.vue?vue&type=script&lang=js&"
export * from "./ProductCardPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports